module.exports = __webpack_public_path__ + "img/order-confirmed.8e65793f.svg";